import * as z from "zod";

/**
 * An email address as Nexxt keeps it, in lowercase: an address is compared as text (the first sign-in of a user, the
 * link of a contact, the copies of an email). One format for every domain that stores one.
 */
export const emailAddress = z.email().max(320).toLowerCase();
